module.exports = __webpack_public_path__ + "img/first-date.5def5c09.png";